import React, { useRef, useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAddWorkflowGroupMutation, api } from "../../../redux/api";
import { treeActions } from "../../../redux/slices/treeSlice";
import inputValidation from "../../../utils/inputValidation";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

export const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function NewWorkflowGroup(props) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const [wfgName, setwfgName] = useState("");
  const error = useRef();
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.queryParams);
  const [addWorkflowGroup, { isLoading }] = useAddWorkflowGroupMutation();
  const [valid, setValid] = useState(true);
  const [openSnakbar, setOpenSnakbar] = useState(false);
  const [message, setMessage] = useState();

  const handleOkClick = () => {
    if (validateInput()) {
      addWorkflowGroup({
        account: account,
        workflowGroupName: encodeURIComponent(wfgName),
      }).then((response) => {
        if (response.data.current_state === "SUCCESS") {
          setwfgName("");
          dispatch(
            treeActions.setLeftTreeContextActionValue({
              screen: parentScreen,
              data: response?.data.workflow_name,
            })
          );
          dispatch(
            api.endpoints.getInboundTemplateList.initiate(
              { account },
              { subscribe: false, forceRefetch: true }
            )
          );
          dispatch(
            api.endpoints.getOutboundTemplateList.initiate(
              { account },
              { subscribe: false, forceRefetch: true }
            )
          );
          dispatch(
            api.endpoints.getWorkflows.initiate(
              { account },
              { subscribe: false, forceRefetch: true }
            )
          )
          props.toggle();
          setOpenSnakbar(true);
          setMessage(response.data.message);
        } else {
          error.current.textContent = response.data.message;
          setValid(false);
        }
      });
    }
  };
  const handleCancelClick = () => {
    setValid(true);
    props.toggle();
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnakbar(false);
  };
  const validateInput = () => {
    let inputFieldValue = wfgName;
    if (inputValidation(inputFieldValue) === "") {
      error.current.textContent = t("BOX_ENTER_NEW_NM_FOR_NEW_WF_GROUP");
      setValid(false);
      return false;
    } else if (inputValidation(inputFieldValue) === "invalid") {
      error.current.textContent = t(
        "BOX_WF_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES"
      );
      setValid(false);
      return false;
    } else if(inputFieldValue.length > 50){
      const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");
      error.current.textContent = errorMsg;
      setValid(false);
      return false;
    }
    return true;
  };

  return (
    <>
      <Dialog onClose={props.onClose} open={props.modalOpen} maxWidth="xs">
        <DialogTitle className="dialog-header">
          <div className="title">{t("DIAG_NEW_WORKFLOW_GROUP_TIT")}</div>
          <div className="description">{t("DIAG_NEW_WORKFLOW_GROUP_DESC")}</div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers>
          <div className={"default-delimiter-field"}>
            {/* <label>{t("LBL_NEW_WF_GROUP_NAME")}</label> */}
            <TextField
              variant="outlined"
              size="small"
              type="text"
              autoFocus={true}
              autoComplete="off"
              value={wfgName}
              label={t("LBL_NEW_WF_GROUP_NAME")}
              error={!valid}
              onChange={(e) => {
                if(e.target.value.length > 50) {
                  const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");
                  error.current.textContent = errorMsg;
                  return;
                }
                setwfgName(e.target.value);
                error.current.textContent = "";
                setValid(true);
              }}
            />
          </div>
          <p className="error" ref={error}></p>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={!valid}
            onClick={() => {
              handleOkClick();
            }}>
            {isLoading ? <CircularProgress  size={"20px"}/> : t("BTN_OK")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={handleCancelClick}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnakbar}
        autoHideDuration={6000}
        onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default NewWorkflowGroup;
